import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://efaajukngkedpmrrkxjs.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_tkJOscvT_uyI_UwfQc8BqQ_vTgNQzwg';

if (!supabaseUrl || !supabaseKey) {
  console.error('Supabase URL or Key is missing.');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Sekundärer Client speziell für den Admin, um neue Nutzer anzulegen,
// ohne die eigene Admin-Sitzung auszuloggen.
export const supabaseAdmin = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false
  }
});
